define('mapbox-gl-leaflet',['leaflet', 'mapboxProvider'], function (L, mapboxProvider) {

    L.MapboxGL = L.Layer.extend({

        initialize: function (options) {
            L.setOptions(this, options);

            if (options.renderer && options.renderer.accessToken) {
                mapboxProvider.getMapbox().accessToken = options.renderer.accessToken;
            } else {
                throw new Error('You should provide a Mapbox GL access token as a token option.');
            }

        },

        _getPane: function () {
            return this._parentPane || this._map.getPanes().tilePane;
        },

        _setPane: function (pane) {
            this._parentPane = pane;
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onAdd: function (map) {
            this._map = map;

            if (!this._glContainer) {
                this._initContainer();
            }

            this._getPane().appendChild(this._glContainer);

            this._initGL();

            this._offset = this._map.containerPointToLayerPoint([0, 0]);

            // work around https://github.com/mapbox/mapbox-gl-leaflet/issues/47
            if (map.options.zoomAnimation) {
                L.DomEvent.on(map._proxy, L.DomUtil.TRANSITION_END, this._transitionEnd, this);
            }
            this._update();
        },

        onRemove: function (map) {
            map._removeZoomLimit(this);
            if (this._map.options.zoomAnimation) {
                L.DomEvent.off(this._map._proxy, L.DomUtil.TRANSITION_END, this._transitionEnd, this);
            }

            this._getPane().removeChild(this._glContainer);
            this._glMap.remove();
            this._glMap = null;
        },

        getEvents: function () {
            return {
                move: this._update,
                zoomanim: this._animateZoom, // apply the zoom animation to the <canvas>
                zoom: this._pinchZoom, // animate every zoom event for smoother pinch-zooming
                zoomend: this._zoomEnd
            };
        },

        _initContainer: function () {
            var container = this._glContainer = L.DomUtil.create('div', 'leaflet-gl-layer');

            var size = this._map.getSize();
            container.style.width = size.x + 'px';
            container.style.height = size.y + 'px';
        },

        _initGL: function () {
            var center = this._map.getCenter();

            var options = L.extend({}, this.options.renderer, {
                container: this._glContainer,
                interactive: false,
                center: [center.lng, center.lat],
                zoom: this._map.getZoom() - 1,
                attributionControl: false
            });

            this._glMap = new (mapboxProvider.getMapbox()).Map(options);

            // allow GL base map to pan beyond min/max latitudes
            this._glMap.transform.latRange = null;

            // treat child <canvas> element like L.ImageOverlay
            L.DomUtil.addClass(this._glMap._canvas, 'leaflet-image-layer');
            L.DomUtil.addClass(this._glMap._canvas, 'leaflet-zoom-animated');
        },

        _update: function () {
            // update the offset so we can correct for it later when we zoom
            this._offset = this._map.containerPointToLayerPoint([0, 0]);

            var size = this._map.getSize(),
              container = this._glContainer,
              gl = this._glMap,
              topLeft = this._map.containerPointToLayerPoint([0, 0]);

            L.DomUtil.setPosition(container, topLeft);

            var center = this._map.getCenter();

            // gl.setView([center.lat, center.lng], this._map.getZoom() - 1, 0);
            // calling setView directly causes sync issues because it uses requestAnimFrame

            var tr = gl.transform;
            tr.center = mapboxProvider.getMapbox().LngLat.convert([center.lng, center.lat]);
            tr.zoom = this._map.getZoom() - 1;

            if (gl.transform.width !== size.x || gl.transform.height !== size.y) {
                container.style.width = size.x + 'px';
                container.style.height = size.y + 'px';
                if (gl._resize !== null && gl._resize !== undefined) {
                    gl._resize();
                } else {
                    gl.resize();
                }
            } else {
                gl._update();
            }
        },

        // update the map constantly during a pinch zoom
        _pinchZoom: function (e) {
            this._glMap.jumpTo({
                zoom: this._map.getZoom() - 1,
                center: this._map.getCenter()
            });
        },

        // borrowed from L.ImageOverlay https://github.com/Leaflet/Leaflet/blob/master/src/layer/ImageOverlay.js#L139-L144
        _animateZoom: function (e) {
            var scale = this._map.getZoomScale(e.zoom),
              offset = this._map._latLngToNewLayerPoint(this._map.getBounds().getNorthWest(), e.zoom, e.center);

            L.DomUtil.setTransform(this._glMap._canvas, offset.subtract(this._offset), scale);
        },

        _zoomEnd: function () {
            var scale = this._map.getZoomScale(this._map.getZoom()),
              offset = this._map._latLngToNewLayerPoint(this._map.getBounds().getNorthWest(), this._map.getZoom(), this._map.getCenter());

            L.DomUtil.setTransform(this._glMap._canvas, offset.subtract(this._offset), scale);
            this._update();
        },

        _transitionEnd: function (e) {
            L.Util.requestAnimFrame(function () {
                var zoom = this._map.getZoom(),
                  center = this._map.getCenter(),
                  offset = this._map.latLngToContainerPoint(this._map.getBounds().getNorthWest());

                // reset the scale and offset
                L.DomUtil.setTransform(this._glMap._canvas, offset, 1);

                // enable panning once the gl map is ready again
                this._glMap.once('moveend', L.Util.bind(function () {
                    this._zoomEnd();
                }, this));

                // update the map position
                this._glMap.jumpTo({
                    center: center,
                    zoom: zoom - 1
                });
            }, this);
        }
    });

    L.mapboxGL = function (options) {
        return new L.MapboxGL(options);
    };

    return L.MapboxGL;
});

